import React from 'react';
import { NoData, Poppins } from 'src/common';
import { formatCurrency } from 'src/utils/misc';
import _ from 'lodash';

export const renderVariableValue = (
  value: number | undefined | null,
  currency: boolean,
  showNoData: boolean,
): JSX.Element => {
  return (
    <>
      {!_.isNil(value) ? (
        <div>
          <Poppins px={14}>{formatCurrency(value, { disablePrefix: !currency })}</Poppins>
        </div>
      ) : (
        <>{showNoData && <NoData iconOnly />}</>
      )}
    </>
  );
};

export const getControlName = (
  library: Array<{
    id: any;
    name: string;
    shortname?: string | null;
    control_identifier?: string | null;
  }>,
  uxId: string,
) => {
  return library.find((el) => el.id === uxId)?.name;
};
